import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CustomsTarifItem, CustomsTarifService } from '@app/services/customs-tarif.service';
import { DiscountGroupProductItem, DiscountGroupService } from '@app/services/discount-group.service';
import { ProductGet, ProductService, ResourceItem } from '@app/services/product.service';
import { forkJoin, from, ReplaySubject, Subject, switchMap, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'tt-product-purchase-form',
    templateUrl: './product-purchase-form.component.html',
    styleUrls: ['./product-purchase-form.component.css'],
})
export class ProductPurchaseFormComponent {
    @Input()
    public set params(value: ProductGet | undefined) {
        this.setParams(value);
    }
    public get params() {
        return this._params;
    }
    private _params?: ProductGet;

    @Output()
    public paramsChange = new EventEmitter<ProductGet>();

    private setParams(value: ProductGet | undefined) {
        this._params = value;

        if (!!value) {
            this.params$.next(value);
        }
    }

    private destroy$ = new Subject<void>();

    private params$ = new ReplaySubject<ProductGet>(1);

    public customsTarifs: CustomsTarifItem[] = [];

    public discountGroupProducts: DiscountGroupProductItem[] = [];

    constructor(
        private product: ProductService,
        private customsTarif: CustomsTarifService,
        private discountGroup: DiscountGroupService,

        private cdr: ChangeDetectorRef,
    ) {}

    public searchResources = async () => {
        return this.product.searchResources({ resource_searchtext: this.params?.special_prod_name_view ?? '' });
    };

    public onResourceSelected(event?: ResourceItem) {
        if (!this.params) return;

        this.params.special_prod_id_view = event?.item_id ?? '';
        this.params.special_prod_name_view = event?.item_name ?? '';

        this.onChanged('special_prod_id_view');

        this.cdr.markForCheck();
    }

    public onChanged(key: keyof ProductGet) {
        if (!this.params) return;

        this.paramsChange.emit(this.params);
    }

    private loadStaticData() {
        forkJoin({
            customsTarifs: from(this.customsTarif.getCustomsTarifs()),
            discountGroupProducts: from(this.discountGroup.getDiscountGroupProducts({ add_from_prodgrp: '1' })),
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe((result) => {
                this.customsTarifs = result.customsTarifs;
                this.discountGroupProducts = result.discountGroupProducts;
                this.cdr.markForCheck();
            });
    }

    ngOnInit(): void {
        this.loadStaticData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.params = changes['params'].currentValue;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
